import { ColorProp } from '../types/color';
import { Theme } from '../styles';
import { resolveThemeColorByPath } from './resolveThemeColorByPath';

export function resolveThemeColorProp(theme: Theme, color: ColorProp) {
  return typeof color === 'function'
    ? color(theme)
    : resolveThemeColorByPath(theme, color);
}
